var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "editable",
          rawName: "v-editable",
          value: _vm.blok,
          expression: "blok",
        },
      ],
      staticClass: "blok-date",
      style: { fontSize: _vm.fontSize },
    },
    [
      _vm.blok.labeled
        ? _c("span", [_vm._v(_vm._s(_vm.blok.label))])
        : _vm._e(),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.convertedDate))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }